import angular from 'angular';
import MsgCenterController from './MsgCenterCtrl';
import uiBootstrapDropdown from "angular-ui-bootstrap/src/dropdown/index";
import angularToastr from 'angular-toastr';
import anularGettext from 'angular-gettext';
/**
 * MessageCenter module based on msgCenter from blur admin
 *
 * @namespace cms.MessageCenter
 *
 * @see {@link ./node_modules/blur_admin/src/app/theme/components/msgCenter}
 */
export default angular.module('cms.MessageCenter', [uiBootstrapDropdown, angularToastr, anularGettext])
    .component('msgCenter', {
        restrict: 'E',
        template: require('./msgCenter.html'),
        controller: MsgCenterController
    }).name;



// WEBPACK FOOTER //
// ./src/cmsCore/MessageCenter/msgCenter.directive.js